var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{class:_vm.color? 'phone-btn sidebar-color' : 'phone-btn',attrs:{"href":"tel:+14508448444"}},[_c('div',{staticClass:"phone"},[_c('b-icon',{attrs:{"icon":"telephone-fill","aria-hidden":"true"}}),_vm._v("  (450) 844-8444")],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }